import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { GroupLeaderResponse } from "@/types/admin";

interface SurveyTextAreaProps {
  label: string;
  field: keyof GroupLeaderResponse;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SurveyTextArea = ({
  label,
  field,
  value,
  onChange,
  placeholder,
}: SurveyTextAreaProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={field}>{label}</Label>
      <Textarea
        id={field}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};